import { WEEKDAYS } from "@/constants/dates"
import { atom } from "jotai"
import { z } from "zod"

export const workingScheduleSchema = z.object({
	workingWeekDays: z.array(z.string()),
	workingHours: z.array(z.string()),
	considerHolidays: z.boolean(),
})

export type WorkingSchedule = z.infer<typeof workingScheduleSchema>

export const defaultWorkingSchedule: WorkingSchedule = {
	workingWeekDays: WEEKDAYS.slice(0, 5),
	workingHours: ["08:00", "17:00"],
	considerHolidays: false,
}
export const workingScheduleDraftAtom = atom<WorkingSchedule>(defaultWorkingSchedule)
